module.exports = __webpack_public_path__ + "static/media/world blue.60f36508.png";